import * as Constants from '../constants/constants';

const clog = (text, data, scope=0, color_size=[null, null]) => {
    if (Constants.DEBUG_SHOW_ARRAY.includes(scope)){
        console.log('%c ' + text, 'color: ' + String(color_size[0]) +'; font-size: ' + String(color_size[1]) + 'px;', data);
    }
}
export default clog;
